import React from "react";
import { Box } from "@mui/material";

const AnimatedBackground: React.FC = () => {
  // Generate random particles
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 5}s`,
    animationDuration: `${15 + Math.random() * 10}s`,
    size: Math.random() * 4 + 2,
  }));

  return (
    <>
      {/* Animated gradient background */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(135deg, #0a0e27 0%, #141b3d 50%, #0a0e27 100%)",
          zIndex: 0,
        }}
      />

      {/* Animated gradient overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 50%, rgba(0, 168, 255, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(0, 102, 204, 0.15) 0%, transparent 50%)",
          animation: "gradientShift 10s ease-in-out infinite",
          "@keyframes gradientShift": {
            "0%, 100%": {
              opacity: 1,
              transform: "scale(1)",
            },
            "50%": {
              opacity: 0.7,
              transform: "scale(1.1)",
            },
          },
          zIndex: 0,
        }}
      />

      {/* Grid pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            linear-gradient(rgba(0, 168, 255, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 168, 255, 0.03) 1px, transparent 1px)
          `,
          backgroundSize: "50px 50px",
          animation: "gridMove 20s linear infinite",
          "@keyframes gridMove": {
            "0%": {
              transform: "translate(0, 0)",
            },
            "100%": {
              transform: "translate(50px, 50px)",
            },
          },
          zIndex: 0,
        }}
      />

      {/* Floating particles */}
      {particles.map((particle) => (
        <Box
          key={particle.id}
          sx={{
            position: "absolute",
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            borderRadius: "50%",
            background: "rgba(0, 168, 255, 0.4)",
            boxShadow: "0 0 10px rgba(0, 168, 255, 0.5)",
            left: particle.left,
            top: "-10px",
            animation: `float ${particle.animationDuration} linear infinite`,
            animationDelay: particle.animationDelay,
            "@keyframes float": {
              "0%": {
                transform: "translateY(0) translateX(0)",
                opacity: 0,
              },
              "10%": {
                opacity: 1,
              },
              "90%": {
                opacity: 1,
              },
              "100%": {
                transform: "translateY(100vh) translateX(50px)",
                opacity: 0,
              },
            },
            zIndex: 0,
          }}
        />
      ))}

      {/* Floating geometric shapes */}
      <Box
        sx={{
          position: "absolute",
          top: "20%",
          left: "10%",
          width: "100px",
          height: "100px",
          border: "2px solid rgba(0, 168, 255, 0.2)",
          borderRadius: "12px",
          animation: "floatShape 15s ease-in-out infinite",
          "@keyframes floatShape": {
            "0%, 100%": {
              transform: "translateY(0) rotate(0deg)",
            },
            "50%": {
              transform: "translateY(-30px) rotate(180deg)",
            },
          },
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: "20%",
          right: "15%",
          width: "80px",
          height: "80px",
          border: "2px solid rgba(0, 102, 204, 0.2)",
          borderRadius: "50%",
          animation: "floatShape2 12s ease-in-out infinite",
          "@keyframes floatShape2": {
            "0%, 100%": {
              transform: "translateY(0) translateX(0)",
            },
            "50%": {
              transform: "translateY(30px) translateX(-20px)",
            },
          },
          zIndex: 0,
        }}
      />

      {/* Light beams */}
      <Box
        sx={{
          position: "absolute",
          top: "-50%",
          left: "20%",
          width: "2px",
          height: "200%",
          background:
            "linear-gradient(to bottom, transparent, rgba(0, 168, 255, 0.1), transparent)",
          transform: "rotate(15deg)",
          animation: "beamMove 8s ease-in-out infinite",
          "@keyframes beamMove": {
            "0%, 100%": {
              opacity: 0.3,
            },
            "50%": {
              opacity: 0.8,
            },
          },
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "-50%",
          right: "30%",
          width: "2px",
          height: "200%",
          background:
            "linear-gradient(to bottom, transparent, rgba(0, 102, 204, 0.1), transparent)",
          transform: "rotate(-15deg)",
          animation: "beamMove 10s ease-in-out infinite",
          animationDelay: "2s",
          "@keyframes beamMove": {
            "0%, 100%": {
              opacity: 0.3,
            },
            "50%": {
              opacity: 0.8,
            },
          },
          zIndex: 0,
        }}
      />
    </>
  );
};

export default AnimatedBackground;
